<template>
  <div class="subject-box" style="height: calc(100% - 84px);">
    <ScrollBox>
      <div class="subject-box-title">
        <div class="title-left">
          <p class="china-title">{{currentQuestionList1.tips_cnname}}</p>
          <p class="en-title">{{currentQuestionList1.tips_enname}}</p>
        </div>
        <div class="title-right" v-if="currentQuestionList1.has_audio==1">
          <div class="audio-add" @click="playAudio">
            <div class="audio-box" style="position:relative;z-index:10;"></div>
            <audio
              class="audio"
              id="audioPlay"
              ref="audio"
              controls
              :src="currentQuestionList1.question_audio"
              autoplay
            ></audio>
          </div>
        </div>
      </div>
      <div class="subject-content-box flex-align">
        <div class="subject-content connection-type">
          <!-- 图连图 -->
          <!-- <div class="Diagram" v-if="category==0">
            <div class="topic-name">请把合起来的10只鸟的相连</div>
            <div class="canvas-box" style="position:relative;" ref="canvasAll" >
              <div style="position:relative;z-index:2">
                <div class="Diagram-top Diagram-common" ref="canvasTop">
                  <div class="item" v-for="(item,index) of imgList1" :key="index" @click="itemClick(item,index,$event)">
                    <img :src="item.img" alt />
                  </div>
                </div>
                <div class="Diagram-bottom Diagram-common" ref="canvasBottom">
                  <div class="item" v-for="(item,index) of imgList1" :key="index" @click="itemClick1(item,index,$event)">
                    <img :src="item.img" alt />
                  </div>
                </div>
              </div>
              <canvas class="canvas" id="canvasAll"  style="position:absolute;left:0;top:0;z-index:-1;"></canvas>
              <canvas class="backcanvas" id="canvasAll1" style="position:absolute;left:0;top:0;z-index:-2;"></canvas>
            </div>

          </div>-->
          <!-- 字连字 -->
          <div class="Word-ligature" v-if="category==1">
            <div class="topic-name">{{currentQuestionList1.question_title}}</div>
            <div id="matching" class="canvas-box mt20" style="position:relative;">
              <div
                class="my-canvas-area"
                style="position: relative;z-index: 2;"
                @touchstart.stop.prevent="touchstart"
                @touchmove.stop.prevent="touchmove"
                @touchend.stop.prevent="touchend"
              >
                <div class="Word-ligature-top Word-ligature-common matching-top">
                  <div class="item-box" v-for="(item,index) of wordList1" :key="index">
                    <div
                      class="item1 item"
                      v-if="item.answers_isimg==0"
                      @mousedown.stop.prevent="mousedown([0, index])"
                      @mouseup.stop.prevent="mouseup([0, index])"
                    >{{item.answers_option}}</div>
                    <div
                      class="item2 item"
                      v-if="item.answers_isimg==1"
                      @mousedown.stop.prevent="mousedown([0, index])"
                      @mouseup.stop.prevent="mouseup([0, index])"
                    >
                      <img :src="item.answers_optionimg" alt />
                    </div>
                  </div>
                </div>
                <div class="Word-ligature-bottom Word-ligature-common">
                  <div class="item-box" v-for="(item,index) of wordList2" :key="index">
                    <div
                      class="item1 item"
                      v-if="item.answers_isimg==0"
                      @mousedown.stop.prevent="mousedown([1, index])"
                      @mouseup.stop.prevent="mouseup([1, index])"
                    >{{item.answers_option}}</div>
                    <div
                      class="item2 item"
                      v-if="item.answers_isimg==1"
                      @mousedown.stop.prevent="mousedown([1, index])"
                      @mouseup.stop.prevent="mouseup([1, index])"
                    >
                      <img :src="item.answers_optionimg" alt />
                    </div>
                  </div>
                </div>
              </div>
              <canvas class="backcanvas" id="backcanvas"></canvas>
            </div>
          </div>
          <!-- 图连字 -->
          <!-- <div class="Picture-ligature Diagram Word-ligature" v-if="category==2">
            <div class="canvas-box">
              <div class="Diagram-common">
                <div class="item" v-for="(item,index) of imgList1" :key="index" @click="itemClick(item,index)">
                  <img :src="item.img" alt />
                </div>

              </div>
              <div class="Word-ligature-common">
                <div class="item" v-for="(item,index) of wordList2" :key="index" @click="itemClick1(item,index)">
                  {{item.word}}
                </div>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </ScrollBox>
  </div>
</template>

<script>
import ScrollBox from "@/components/ScrollBox";
const JIAN_XI_H = 20; // 横向 间隙
const JIAN_XI_V = 140; // 竖向 间隙
const ITEM_HEIGHT1 = 140; // 高度
// const ITEM_HEIGHT1 = 140; // 高度
export default {
  name: "Connection",
  props: {
    currentQuestionList: {
      type: Object
    },
    //当前点击到 第几题
    currentId: {
      type: Number
    },
    //当前题目答案格式
    anwsersAll: {
      type: Object
    },
    //所有题目答案格式
    anwsersListAll: {
      type: Array
    }
  },
  components: {
    ScrollBox
  },
  data() {
    return {
      currentQuestionList1: {},
      category: 1,
      question: {
        word: "<br/>Matt:$B$<br/>Chevady:It is Saturday!Let is go out and play."
      },
      falgs: "article",
      disabled: false,

      // imgList1: [],
      // imgList2: [],

      startX: "", //开始的 x坐标
      startY: "", //开始的 y坐标
      endX: "", //结束的 x坐标
      endY: "", //结束的 y坐标
      wordList1: [],
      wordList2: [],
      clickItem: false,
      isMoving: false, // 移动端 移动中

      // 存储 画的所有线
      drawList: [],
      // 正在画的线
      currentDraw: {
        curFromOrigin: -1,
        drawFrom: [],
        drawTo: [],
        startIndex: -1,
        endIndex: -1,
        start: {
          x: 0,
          y: 0
        },
        end: {
          x: 0,
          y: 0
        }
      },
      anwsersReplace: [],
      myPoints: [] //坐标
    };
  },
  watch: {
    getData(n, o) {
      let index = this.currentId;
      this.currentQuestionList1 = n;
      this.wordList1 = n.option.top;
      this.wordList2 = n.option.bottom;
      this.anwsersAll.topList = n.option.top;
      this.anwsersAll.bottomList = n.option.bottom;
      this.anwsersListAll[index].answers = [];
     console.log(this.anwsersAll)
      n.option.top.forEach((item1,index1)=>{
        this.anwsersListAll[index].answers.push([-1, -1]);
      })
     
      if(this.anwsersAll.pointsArr.length == n.option.top.length){
        console.log("当前题目有答案");
        
        this.drawList = this.anwsersListAll[index].pointsArr;
        this.$nextTick(() => {
          this.init();
          this.drawList.forEach(e => {
            this.strockline(e.points);
          });
        });
      }else{
        console.log("当前题目没有答案");
        this.drawList = [];
        this.canvas = this.getElement("#backcanvas");
        this.context = this.canvas.getContext("2d");
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        console.log(this.getElement("#backcanvas"));
        // n.option.top.forEach((item1,index1)=>{
        //   this.anwsersListAll[index].answers.push([-1, -1]);
        // })
        // this.anwsersReplace = [];
        // n.option.top.forEach(e => {
        //   this.anwsersReplace.push([-1, -1]);
        // });
        console.log(this.myPoints);
        if (n.option.top.length > 0 && n.option.bottom.length > 0) {
          this.$nextTick(() => {
            this.init();
          });
        }
      }

      // this.anwsersListAll[index].answers.push([-1, -1]);
      console.log(this.anwsersAll, this.anwsersListAll);
      console.log(this.anwsersAll.answers, "答案");

      // if (this.anwsersAll.answers.length > 0) {
      //   //当前题目有答案
      //   // console.log(this.anwsersListAll[index].answers);
      //   // this.anwsersReplace = this.anwsersListAll[index].answers;
      //   this.$nextTick(() => {
      //     this.init();
      //     this.anwsersListAll[index].pointsArr.forEach(e => {
      //       this.strockline(e.points);
      //     });
      //   });
      // } else {
      //   //当前题目没有答案
      //   console.log("当前题目没有答案");
      //   this.drawList = [];
      //   this.canvas = this.getElement("#backcanvas");
      //   this.context = this.canvas.getContext("2d");
      //   this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      //   console.log(this.getElement("#backcanvas"));

      //   // this.anwsersReplace = [];
      //   // n.option.top.forEach(e => {
      //   //   this.anwsersReplace.push([-1, -1]);
      //   // });
      //   console.log(this.myPoints);
      //   if (n.option.top.length > 0 && n.option.bottom.length > 0) {
      //     this.$nextTick(() => {
      //       this.init();
      //     });
      //   }
      // }
    },
    getData1(n, o) {
      console.log(22222);
    },
    quetionClick(n, o) {
      console.log(n, o);
    }
  },
  computed: {
    getData() {
      return this.currentQuestionList;
    },
    getData1() {
      return this.propChild;
    },
    quetionClick() {
      return this.currentId;
    }
  },
  created() {
    this.currentQuestionList1 = this.propChild
      ? this.propChild
      : this.currentQuestionList;
    console.log("当前题目答案---------------", this.anwsersAll);
    // if(this.context){
    //   this.clearCanvas();
    // }
  },
  mounted() {
    // this.init();
    window.addEventListener("popstate", this.goBack, false);
    document.addEventListener(
      "mousedown",
      () => {
        this.clickItem = false;
        console.log("mousedown");
      },
      false
    );
    document.addEventListener(
      "mouseup",
      () => {
        this.clickItem = false;
        console.log("mouseup");
        this.currentDraw.start.x = 0;
        this.currentDraw.start.y = 0;
        this.currentDraw.end.x = 0;
        this.currentDraw.end.y = 0;
        this.currentDraw.startIndex = -1;
        this.currentDraw.endIndex = -1;
        this.repainCanvas();
      },
      false
    );
    document.addEventListener(
      "touchend",
      () => {
        this.clickItem = false;
        console.log("mouseup");
        this.currentDraw.start.x = 0;
        this.currentDraw.start.y = 0;
        this.currentDraw.end.x = 0;
        this.currentDraw.end.y = 0;
        this.currentDraw.startIndex = -1;
        this.currentDraw.endIndex = -1;

        this.from = -1;
        this.endFrom = -1;
        this.startIndex = -1;
        this.endIndex = -1;
        this.isMoving = false;
        this.repainCanvas();
      },
      false
    );
  },
  methods: {
    playAudio() {
      console.log(333);
      let audio = this.$refs.audio;
      audio.play();
    },
    repainCanvas() {
      this.clearCanvas();
      this.drawList.forEach(e => {
        this.strockline(e.points);
      });
    },
    dragstart() {
      return false;
    },

    touchstart(e) {
      let canMove = false;

      this.isMoving = false;
      this.from = -1; // 0 上， 1 下
      this.startIndex = -1; // 开始 的 下标

      console.log(e.touches[0]);
      let curCoordinate = e.touches[0];
      this.coordinatesList.top.forEach((e, i) => {
        if (
          e.x1 < curCoordinate.pageX &&
          e.x2 > curCoordinate.pageX &&
          e.y1 < curCoordinate.pageY &&
          e.y2 > curCoordinate.pageY
        ) {
          canMove = true;
          this.from = 0;
          this.startIndex = i;
          console.log("上");
        }
      });
      if (!canMove) {
        this.coordinatesList.bottom.forEach((e, i) => {
          if (
            e.x1 < curCoordinate.pageX &&
            e.x2 > curCoordinate.pageX &&
            e.y1 < curCoordinate.pageY &&
            e.y2 > curCoordinate.pageY
          ) {
            canMove = true;
            this.from = 1;
            this.startIndex = i;
            console.log("下");
          }
        });
      }

      if (canMove) {
        this.isMoving = true;
        this.mousedown([this.from, this.startIndex]);
      }
    },

    touchmove(e) {
      // console.log(this.isMoving);
      if (this.isMoving) {
        // console.log(e.touches[0]);
        let curCoordinate = e.touches[0];
        this.moveX = curCoordinate.pageX;
        this.moveY = curCoordinate.pageY;
      }
    },
    touchend() {
      this.endIndex = -1;
      this.endFrom = -1;
      this.coordinatesList.top.forEach((e, i) => {
        if (
          e.x1 < this.moveX &&
          e.x2 > this.moveX &&
          e.y1 < this.moveY &&
          e.y2 > this.moveY
        ) {
          this.endIndex = i;
          this.endFrom = 0;
        }
      });
      this.coordinatesList.bottom.forEach((e, i) => {
        if (
          e.x1 < this.moveX &&
          e.x2 > this.moveX &&
          e.y1 < this.moveY &&
          e.y2 > this.moveY
        ) {
          this.endIndex = i;
          this.endFrom = 1;
        }
      });

      if (this.endIndex > -1) {
        if (this.isMoving) {
          this.isMoving = false;
          console.log("over");
          console.log(this.endIndex, this.endFrom);
          if (this.from != this.endFrom) {
            console.log([this.endFrom, this.endIndex]);
            this.mouseup([this.endFrom, this.endIndex]);
          }
        } else {
          console.log(123123);
        }
      }
    },

    mousedown(v1) {
      console.log(v1);
      this.clickItem = true;
      this.curFromOrigin = v1[0]; // 0 上, 1 下
      let index = -1;
      // this.drawList =[];
      if (this.curFromOrigin == 0) {
        console.log(v1[1]); //上面开始 下标
        // 上边 开始
        this.currentDraw.drawFrom = v1;
        this.currentDraw.start.x =
          this.currentDraw.drawFrom[1] * JIAN_XI_H +
          this.itemWidth / 2 +
          this.itemWidth * this.currentDraw.drawFrom[1];
        this.currentDraw.startIndex = v1[1];
        this.currentDraw.start.y = ITEM_HEIGHT1;
        // this.anwsersReplace[v1[1]][0] = this.wordList1[
        //   v1[1]
        // ].answers_optionname;

        // this.drawList.forEach((e, i) => {
        //   console.log(e, i);
        // });

        this.drawList.forEach((e, i) => {
          if (e.startIndex == v1[1]) {
            index = i;
          }
        });

        if (index > -1) {
          let arr = this.drawList.filter((e, i) => i != index);
          this.drawList = [].concat(arr);
          // this.anwsersReplace[index][1] = -1;
          this.repainCanvas();
        }
      } else if (this.curFromOrigin == 1) {
        // 下边 开始
        this.currentDraw.drawTo = v1;
        this.currentDraw.end.x =
          this.currentDraw.drawTo[1] * JIAN_XI_H +
          this.itemWidth / 2 +
          this.itemWidth * this.currentDraw.drawTo[1];
        this.currentDraw.endIndex = v1[1];
        this.currentDraw.end.y = JIAN_XI_V + ITEM_HEIGHT1;

        console.log(
          v1[1],
          this.drawList,
          "下边 开始",
          this.currentDraw.startIndex,
          this.currentDraw.endIndex
        );
        // this.anwsersReplace[v1[1]][1] = this.wordList2[
        //   v1[1]
        // ].answers_optionname;
        this.drawList.forEach((e, i) => {
          if (e.endIndex == v1[1]) {
            index = i;
          }
        });

        if (index > -1) {
          let arr = this.drawList.filter((e, i) => i != index);
          this.drawList = [].concat(arr);
          // this.anwsersReplace[index][0] = -1;
          this.repainCanvas();
        }
      }
    },
    mouseup(v1) {
      let index = -1;
      let indexID = -1;
      let indexID1 = -1;
      if (this.clickItem) {
        // console.log(v1);
        if (this.curFromOrigin != v1[0]) {
          // 0 上, 1 下
          if (v1[0] == 0) {
            // 上边 结束
            this.currentDraw.drawFrom = v1;
            this.currentDraw.start.x =
              this.currentDraw.drawFrom[1] * JIAN_XI_H +
              this.itemWidth / 2 +
              this.itemWidth * this.currentDraw.drawFrom[1];
            this.currentDraw.startIndex = v1[1];
            this.currentDraw.start.y = ITEM_HEIGHT1;
            console.log(
              v1[1],
              this.drawList,
              this.currentDraw.startIndex,
              this.currentDraw.endIndex,
              "上边结束"
            );

            // this.anwsersReplace.forEach((e, i) => {
            //   if (i == this.currentDraw.startIndex)
            // })

            this.drawList.forEach((e, i) => {
              console.log(e);
              if (e.startIndex == v1[1]) {
                index = i;
                // console.log(e.endIndex);
                indexID = e.endIndex;
              }
            });
            if (index > -1) {
              let arr = this.drawList.filter((e, i) => i != index);
              this.drawList = [].concat(arr);
              // this.anwsersReplace[indexID] = [-1, -1];
              this.repainCanvas();
            }

            // this.anwsersReplace[
            //   this.currentDraw.startIndex
            // ][1] = this.wordList2[this.currentDraw.endIndex].answers_optionname;

            // this.anwsersReplace[
            //   this.currentDraw.startIndex
            // ][0] = this.wordList1[
            //   this.currentDraw.startIndex
            // ].answers_optionname;
          } else if (v1[0] == 1) {
            // 下边 结束
            this.currentDraw.drawTo = v1;
            this.currentDraw.end.x =
              this.currentDraw.drawTo[1] * JIAN_XI_H +
              this.itemWidth / 2 +
              this.itemWidth * this.currentDraw.drawTo[1];
            this.currentDraw.endIndex = v1[1];
            this.currentDraw.end.y = JIAN_XI_V + ITEM_HEIGHT1;

            // this.anwsersReplace[
            //   this.currentDraw.startIndex
            // ][1] = this.wordList2[v1[1]].answers_optionname;

            this.drawList.forEach((e, i) => {
              console.log(e);
              console.log(e.endIndex, v1[1]);
              if (e.endIndex == v1[1]) {
                console.log(e.startIndex);
                indexID = e.startIndex;
                index = i;
              }
            });
            if (index > -1) {
              let arr = this.drawList.filter((e, i) => i != index);
              this.drawList = [].concat(arr);
              // this.anwsersReplace[indexID] = [-1, -1];
              this.repainCanvas();
            }
          }
          // console.log(this.anwsersReplace);
          this.drawList.push({
            startIndex: this.currentDraw.startIndex,
            endIndex: this.currentDraw.endIndex,
            points: [
              {
                x: this.currentDraw.start.x,
                y: this.currentDraw.start.y
              },
              {
                x: this.currentDraw.end.x,
                y: this.currentDraw.end.y
              }
            ]
          });
          console.log(this.drawList);
          this.drawList.forEach(e => {
            this.strockline(e.points);
          });
          this.myPoints = [...this.drawList];
          // this.anwsersAll.answers = this.anwsersReplace;
          this.anwsersAll.pointsArr = this.myPoints;
          console.log(this.anwsersAll,'我是答案-----------------')
        } else {
          this.currentDraw.start.x = 0;
          this.currentDraw.start.y = 0;
          this.currentDraw.end.x = 0;
          this.currentDraw.end.y = 0;
          this.currentDraw.startIndex = -1;
          this.currentDraw.endIndex = -1;

          this.from = -1;
          this.endFrom = -1;
          this.startIndex = -1;
          this.endIndex = -1;
          this.isMoving = false;
        }
      }
    },
    init() {
      console.log(this.getElements(".matching-top .item"));
      this.items = this.getElements(".matching-top .item");

      this.itemWidth = this.getElement(".matching-top .item").clientWidth;
      this.itemHeight = this.getElement(".matching-top .item").clientHeight;

      this.canvas = this.getElement("#backcanvas");
      this.context = this.canvas.getContext("2d");
      this.box = this.getElement("#matching");

      // 初始化 容器宽度
      this.box.style.width =
        this.items.length * this.itemWidth +
        (this.items.length - 1) * JIAN_XI_H +
        "px";

      this.initCoordinateInterval();
      this.initCanves();
    },

    // 移动端 初始化 坐标 区间
    initCoordinateInterval() {
      this.coordinatesList = {
        top: [],
        bottom: []
      };
      // console.log(this.box.getBoundingClientRect());
      let boxData = this.box.getBoundingClientRect();

      for (let index = 0; index < this.items.length; index++) {
        this.coordinatesList.top.push({
          x1: boxData.left + this.itemWidth * index + JIAN_XI_H * index,
          x2: boxData.left + this.itemWidth * (index + 1) + JIAN_XI_H * index,
          y1: boxData.top,
          y2: boxData.top + this.itemHeight
        });
        this.coordinatesList.bottom.push({
          x1: boxData.left + this.itemWidth * index + JIAN_XI_H * index,
          x2: boxData.left + this.itemWidth * (index + 1) + JIAN_XI_H * index,
          y1: boxData.top + JIAN_XI_V + this.itemHeight,
          y2: boxData.top + JIAN_XI_V + this.itemHeight * 2
        });
      }
      // console.log(this.coordinatesList);
    },

    // 整个画布清除
    clearCanvas() {
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },

    getElement(className) {
      return document.querySelector(className);
    },
    getElements(classNames) {
      return document.querySelectorAll(classNames);
    },
    initCanves() {
      this.canvas.width = this.box.clientWidth;
      this.canvas.height = this.box.clientHeight;
    },

    // var lastX,lastY;//存放遍历坐标
    strockline(arr) {
      console.log(arr);
      //绘制方法
      this.context.save();
      this.context.beginPath();
      this.context.lineWidth = 2;
      var lastX, lastY, lastX1, lastY1;
      lastX = arr[0].x;
      lastY = arr[0].y;
      lastX1 = arr[1].x;
      lastY1 = arr[1].y;

      this.context.moveTo(lastX, lastY);
      this.context.lineTo(lastX1, lastY1);
      this.context.stroke();
      this.context.restore();
    },
    //考试中 - 是否返回上一个页面
    gobackPrev() {
    }
  },
  destroyed() {
    window.removeEventListener("mousedown", this.events, true);
    window.removeEventListener("mouseup", this.events, true);
    window.removeEventListener("touchend", this.events, true);
  },
  beforeCreate() {
    let that = this;
    window.addEventListener("popstate", this.gobackPrev);
  }
};
</script>

<style lang="less">
.connection-type {
  .backcanvas {
    position: absolute;
    left: 0;
    top: 0;
    // background: rosybrown;
    /* width: 400px;
      height: 400px; */
    z-index: 1;
  }

  .topic-name {
    font-size: 15px;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  /*  图连图  */
  .Diagram {
    .Diagram-common {
      display: flex;
      align-items: center;
      justify-content: center;

      .item {
        width: 140px;
        height: 140px;
        margin-bottom: 80px;
        margin-right: 20px;

        &:last-child {
          margin-right: 0px;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .Diagram-top {
      margin-top: 40px;
    }

    .Diagram-bottom {
      .item {
        margin-bottom: 0;
      }
    }
  }

  /* 字连字 */
  .Word-ligature {
    .Word-ligature-common {
      display: flex;
      align-items: center;

      .item-box {
        &:last-child {
          margin-right: 0px;
        }
      }

      .item2 {
        width: 140px;
        height: 140px;
        // margin-bottom: 80px;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .item1 {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 0px 0px rgba(221, 221, 221, 1);
        border-radius: 8px;
        width: 140px;
        height: 140px;
        // line-height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        // padding: 20px 8px;
        text-align: center;
        // margin-bottom: 80px;
      }
    }

    .Word-ligature-top {
      // margin-top: 40px;
      .item2 {
        margin-bottom: 140px;
      }

      .item1 {
        margin-bottom: 140px;
      }
    }
  }
}
</style>
